import * as React from 'react';

const AuthenticityDiamond24 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m20.35 10.01-3.74-4H7.39l-3.74 4L12 18.36l8.35-8.35ZM7.26 4.51h9.53v.01a1.11 1.11 0 0 1 .8.35l4.11 4.44a1.09 1.09 0 0 1 0 1.53l-8.9 8.92a1.11 1.11 0 0 1-.77.32 1.09 1.09 0 0 1-.77-.32l-9-8.92a1.11 1.11 0 0 1 0-1.53l4.2-4.45a1.1 1.1 0 0 1 .8-.35Zm8.47 4.5 1.53.53a.53.53 0 0 1-.02 1l-1.49.53-.49 1.59a.48.48 0 0 1-.92 0l-.5-1.59-1.49-.53a.53.53 0 0 1 0-1l1.49-.53.5-1.59a.48.48 0 0 1 .92 0l.47 1.59Z",
    clipRule: "evenodd"
  }
));
AuthenticityDiamond24.Size = 24;
AuthenticityDiamond24.Title = "AuthenticityDiamond";

export { AuthenticityDiamond24 as default };
